import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ProtocolFindProductionLogsBodyDto} from '../../dtos/protocolFindProductionLogsBodyDto';

@Injectable({
    providedIn: 'root'
})
export class BigQueryAdminService {

    constructor(private httpClient: HttpClient) {}

    public findProductionLogsForSerialCode(bodyDto: ProtocolFindProductionLogsBodyDto): Observable<any> {
        return this.httpClient.post<any>(environment.apiUrl + 'api/integration/bigquery/v1/query', bodyDto)
            .pipe(map(protocolFindProductionLogsResponseDto => {
                return protocolFindProductionLogsResponseDto;
            }));
    }

    public findProductionLogsForAccount(bodyDto: ProtocolFindProductionLogsBodyDto): Observable<any> {
        return this.httpClient.post<any>(environment.apiUrl + 'api/integration/bigquery/v1/queryByAccountCode', bodyDto)
            .pipe(map(protocolFindProductionLogsResponseDto => {
                return protocolFindProductionLogsResponseDto;
            }));
    }

    public findGoogleLastSync(): Observable<any> {
        return this.httpClient.get<any>(environment.apiUrl + 'api/integration/bigquery/v1/queryLastSync')
            .pipe(map(protocolFindProductionLogsResponseDto => {
                return protocolFindProductionLogsResponseDto;
            }));
    }
}
